import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { ProductSettingsResponse } from './ProductSettingsResponse.types.tsx';

const getProductSettingsUrl = (viewId: string) =>
	fg('jpd_publish_new_api')
		? `${getJpdViewsServicePathPrefix()}/public/v1/views/${viewId}/product-settings`
		: `${getJpdViewsServicePathPrefix()}/public/views/${viewId}/product-settings`;

export const getProductSettings = (): Promise<ProductSettingsResponse> =>
	performGetRequest('/rest/polaris/product-settings');

export const getProductSettingsForSharedViews = async (
	viewId: string,
): Promise<ProductSettingsResponse> => {
	if (!viewId) {
		throw new Error('viewId must be supplied, cannot load financial year data');
	}

	return fetchJson(getProductSettingsUrl(viewId));
};
